import React, {useState} from 'react';
import cx from 'classnames';
import {Form} from '../../../../stores/Form/Form';
import styles from './styles.module.scss';
import {getPlaceholderByColumn} from '../../utils/placeholders';
import {getLang} from '../../../../Localization';
import {prepareColumnTabs} from '../../../../stores/Form/utils';

type Props = {
    currentForm: Form;
};

const lang = getLang();

export const CollapsedFormView = ({currentForm}: Props) => {
    const [visibleColumns] = useState(
        prepareColumnTabs(currentForm, currentForm.columnsTabs)[0]?.TabSection[0]?.Controls || []
    );
    const currentRowData = currentForm.records[currentForm.currentRow];

    const mappedData = visibleColumns.reduce((acc, {Column}, index) => {
        const groupIndex = Math.ceil((index + 1) / 2);
        const group = acc[groupIndex];
        const fieldData = {column: Column, field: currentRowData.getField(Column.id)};

        if (!group) {
            // create column group
            acc[groupIndex] = [];
        }

        acc[groupIndex] = acc[groupIndex].concat(fieldData);

        return acc;
    }, []);

    return (
        <div className={styles.component}>
            {mappedData.map((group, index) => {
                return (
                    <div key={index} className={styles.group}>
                        {group.map((item, groupIndex) => {
                            return (
                                <div className={styles.item} key={groupIndex}>
                                    <div className={cx(styles.itemColumn, styles.label)}>
                                        {item.column.Title}
                                    </div>

                                    <div className={cx(styles.itemColumn, styles.value)}>
                                        {item.field.currentValue ||
                                            getPlaceholderByColumn(item.column, lang) ||
                                            '-'}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};
